// Shared modules between ./guest and ./registered

import "zone.js"